export function isNullOrUndefined(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}

export function isNullUndefinedOrWhiteSpace(value: string | null | undefined): value is null | undefined | "" {
  if (isNullOrUndefined(value) || typeof value !== "string") {
    return true;
  }

  const whiteSpace = " ";
  for (const current of value) {
    if (current !== whiteSpace) {
      return false;
    }
  }

  return true;
}

export function exhaustiveGuard(value: never): never {
  throw Error(`ERROR! Reached forbidden guard function with unexpected value: ${JSON.stringify(value)}`);
}
